<template>
	<div class="px-4">
		<v-subheader>Tabla: Lista Cuentas Contables</v-subheader>
		<accounting-account-table
			:rows="items"
			table-height="0"
		>
			<template v-for="column in columns" slot="header">
				<v-flex
					class="header-table-text"
					:key="column.id"
					xs4
					text-xs-center
				>
					{{ column.name }}
				</v-flex>
			</template>
		</accounting-account-table>
	</div>
</template>

<script>
	import accountingAccountTable from '@/components/accounting-accounts/accounting-account-table';

	function data() {
		return {
			items: [
				{
					id: 1,
					description: 'Descripción Activos',
					level: 1,
					fullName: 'Activos',
					details: [
						{
							id: 1,
							description: 'Descripción Activos corrientes',
							level: 2,
							fullName: 'Activos corrientes - 4536',
							parentId: 1,
							details: [
								{
									id: 1,
									description: 'Descripción Activos corrientes',
									level: 3,
									fullName: 'Activos corrientes - 4536',
									parentId: 1,
								},
								{
									id: 2,
									description: 'Descripción Activos no corrientes',
									level: 3,
									fullName: 'Activos no corrientes - 4576',
									parentId: 1,
									details: [
										{
											id: 1,
											description: 'Descripción Activos corrientes',
											level: 4,
											fullName: 'Activos corrientes - 4536',
											parentId: 2,
										},
										{
											id: 2,
											description: 'Descripción Activos no corrientes',
											level: 4,
											fullName: 'Activos no corrientes - 4576',
											parentId: 2,
										},
									],
								},
							],
						},
						{
							id: 2,
							description: 'Descripción Activos no corrientes',
							level: 2,
							fullName: 'Activos no corrientes - 4576',
							parentId: 1,
							details: [
								{
									id: 1,
									description: 'Descripción Activos corrientes',
									level: 3,
									fullName: 'Activos corrientes - 4536',
									parentId: 2,
								},
								{
									id: 2,
									description: 'Descripción Activos no corrientes',
									level: 3,
									fullName: 'Activos no corrientes - 4576',
									parentId: 2,
								},
							],
						},
					],
				},
				{
					id: 2,
					description: 'Descripción Activos',
					fullName: 'No Activos',
					level: 1,
					details: [
						{
							id: 1,
							description: 'Descripción Activos corrientes',
							level: 2,
							fullName: 'Activos corrientes - 4536',
							parentId: 2,
							details: [
								{
									id: 1,
									description: 'Descripción Activos corrientes',
									level: 3,
									fullName: 'Activos corrientes - 4536',
									parentId: 1,
								},
								{
									id: 2,
									description: 'Descripción Activos no corrientes',
									level: 3,
									fullName: 'Activos no corrientes - 4576',
									parentId: 1,
									details: [
										{
											id: 1,
											description: 'Descripción Activos corrientes',
											level: 4,
											fullName: 'Activos corrientes - 4536',
											parentId: 2,
										},
										{
											id: 2,
											description: 'Descripción Activos no corrientes',
											level: 4,
											fullName: 'Activos no corrientes - 4576',
											parentId: 2,
										},
									],
								},
							],
						},
						{
							id: 2,
							description: 'Descripción Activos no corrientes',
							level: 2,
							fullName: 'Activos no corrientes - 4576',
							parentId: 2,
							details: [
								{
									id: 1,
									description: 'Descripción Activos corrientes',
									level: 3,
									fullName: 'Activos corrientes - 4536',
									parentId: 2,
								},
								{
									id: 2,
									description: 'Descripción Activos no corrientes',
									level: 3,
									fullName: 'Activos no corrientes - 4576',
									parentId: 2,
								},
							],
						},
					],
				},
			],
			columns: [
				{
					id: 1,
					name: 'Título',
					value: 'fullName',
					class: 'xs4',
				},
				{
					id: 2,
					name: 'Descripción',
					value: 'description',
					class: 'xs4',
				},
				{
					id: 3,
					name: 'Acciones',
					value: 'actions',
					class: 'xs4',
				},
			],
		};
	}

	export default {
		name: 'page-components',
		components: {
			accountingAccountTable,
		},
		data,
	};
</script>

<style lang="scss" scoped>
	.table-scroll-text {
		line-height: 1;
	}
</style>


// WEBPACK FOOTER //
// src/pages/page-components.vue